import React, { useEffect } from 'react';
import { useNavigation } from '../../routes/NavigationContext';
import botConfig from '../../bot-config-map.json';

import Header from '../headerone/Main';
import Bredcom from '../Bredcom/Main';
import First from './Main';

function Main() {
  const { currentPath } = useNavigation();

  // Find the correct contact center config based on the current route
  const findConfigForPage = (path) => {
    const keys = Object.keys(botConfig);

    const matchingKey = keys
      .filter((key) => {
        if (key === path) return true; // Exact match
        if (key.endsWith('/*')) return path.startsWith(key.replace('/*', '')); // Match wildcards
        return false;
      })
      .sort((a, b) => b.length - a.length)[0]; // Prioritize more specific matches

    if (matchingKey && matchingKey.endsWith('/*')) {
      const basePath = matchingKey.replace('/*', '');
      if (keys.includes(basePath)) {
        return { ...botConfig[basePath], ...botConfig[matchingKey] };
      }
    }

    return botConfig[matchingKey] || botConfig['/'];
  };

  const contactCenterConfig = findConfigForPage(currentPath)?.contactCenter || {};

  useEffect(() => {
    document.getElementById("title").innerHTML = "Login || State of GTS";
  }, []);

  return (
    <>
      <Header />
      <div className="page-wrapper">
        <Bredcom subtitle="Home" title="Login" subtitledown="Login" />
        <First/>
      </div>
    </>
  );
}

export default Main;
